import React from 'react';
import { Link } from 'react-router';
import { PageHero } from '../components/PageHero';
import { Section } from '../components/Section';
import { Card } from '../components/Card';
import { Button } from '../components/Button';
import useTheme from '../hooks/useTheme';
import { megaGreenData } from '../data/data';
import { getPillStyle } from '../utils/styleVariables';

export const Insights: React.FC = () => {
    const { theme, breakpoint } = useTheme();
    const articles = megaGreenData.insights.articles;

    return (
        <>
            <PageHero
                title="Insights"
                subtitle={megaGreenData.insights.intro}
            />

            <Section>
                <div
                    style={{
                        display: 'grid',
                        gridTemplateColumns: breakpoint.xs || breakpoint.sm ? '1fr' : breakpoint.md ? 'repeat(2, 1fr)' : 'repeat(3, 1fr)',
                        gap: '24px',
                    }}
                >
                    {articles.map((article) => (
                        <Card key={article.slug} hoverable variant="secondary"
                            style={{ display: 'flex', flexDirection: 'column' }}
                        >
                            <div
                                style={{
                                    height: '4px',
                                    background: theme.gradients.button,
                                    borderRadius: `${theme.borderRadius.r1} ${theme.borderRadius.r1} 0 0`,
                                    margin: '-20px -20px 16px -20px',
                                }}
                            />
                            <img src={article.src} alt={article.title} style={{ width: '100%', height: 160, objectFit: 'cover', borderRadius: theme.borderRadius.r1 }} />
                            <h3
                                style={{
                                    paddingTop: '16px',
                                    fontSize: '18px',
                                    fontWeight: 600,
                                    color: theme.text.primary,
                                    marginBottom: '8px',
                                }}
                            >
                                {article.title}
                            </h3>
                            <p
                                style={{
                                    fontSize: '14px',
                                    color: theme.text.muted,
                                    lineHeight: 1.5,
                                    marginBottom: '16px',
                                }}
                            >
                                {article.deck}
                            </p>
                            {article.tags && article.tags.length > 0 && (
                                <div
                                    style={{
                                        display: 'flex',
                                        gap: '8px',
                                        flexWrap: 'wrap',
                                        marginBottom: '16px',
                                    }}
                                >
                                    {article.tags.map((tag, idx) => (
                                        <span
                                            key={idx}
                                            style={{
                                                fontSize: '12px',
                                                padding: '4px 10px',
                                                borderRadius: '12px',
                                                border: '1px solid',
                                                ...getPillStyle(theme, tag),
                                            }}
                                        >
                                            {tag}
                                        </span>
                                    ))}
                                </div>
                            )}
                            <Link to={`/insights/${article.slug}`} style={{
                                textDecoration: 'none'
                                , marginTop: 'auto'
                            }}>
                                <Button variant="secondary" style={{ width: '100%' }}>
                                    Read
                                </Button>
                            </Link>
                        </Card>
                    ))}
                </div>
            </Section>

            <Section
                style={{
                    backgroundColor: theme.background.panel,
                }}
            >
                <div
                    style={{
                        maxWidth: '800px',
                        margin: '0 auto',
                        textAlign: 'center',
                    }}
                >
                    <h2
                        style={{
                            fontSize: breakpoint.xs || breakpoint.sm ? '28px' : '34px',
                            fontWeight: 700,
                            color: theme.text.primary,
                            marginBottom: '16px',
                        }}
                    >
                        Tell us what you're planning
                    </h2>
                    <p
                        style={{
                            fontSize: '16px',
                            color: theme.text.muted,
                            marginBottom: '24px',
                        }}
                    >
                        {megaGreenData.contact.pageIntro}
                    </p>
                    <Link to="/contact" style={{ textDecoration: 'none' }}>
                        <Button variant="primary" style={{ padding: '12px 32px' }}>
                            Request a Consultation
                        </Button>
                    </Link>
                </div>
            </Section>
        </>
    );
};

